export const FileType = {
    BMP: 'bmp',
    JPG: 'jpg',
    PNG: 'png',
    TIF: 'tif'
}


// WEBPACK FOOTER //
// ./src/app/shared/constants/download.constants.ts